export default __webpack_public_path__ + "alberta-fab-patient-inactive.64cf7d6f3bed9ab7d14a.svg";